// extracted by mini-css-extract-plugin
module.exports = {"mobileWidth":"850px","content":"outlinedText-module__content___38TCb"};